// extracted by mini-css-extract-plugin
module.exports = {"filter":"filter___3V1xR","bucket":"bucket___1Ktt_","title":"title___1-OAh"};